import { API_URL } from "constants/ApiUrl";
import fetch from "../auth/FetchInterceptor";
const AgentAnnonceService = {};

AgentAnnonceService.getAll = function (page, searchValue) {
  let url = `${API_URL}/api/agent/announcements?page=${page}&limit=6`;
  if (searchValue) {
    url = url + `&title=${searchValue}`;
  }
  return fetch({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

AgentAnnonceService.getById = function (id) {
  return fetch({
    url: `${API_URL}/api/agent/announcements/${id}`,
    method: "get",
    headers: { "Content-Type": "application/json" },
  });
};

AgentAnnonceService.create = function (annonceData) {
  return fetch({
    url: `${API_URL}/api/agent/announcements`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: annonceData,
  });
};

AgentAnnonceService.update = function (id, annonceData) {
  return fetch({
    url: `${API_URL}/api/agent/announcements/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
    },
    data: annonceData,
  });
};

AgentAnnonceService.delete = function (id) {
  return fetch({
    url: `${API_URL}/api/agent/announcements/${id}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export default AgentAnnonceService;
